import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { provideHooks } from 'redial'
import { selectCustomSupporterPage } from '../../store/customSupporterPages'
import { fetchFundraisingPage, selectFundraisingPage, selectFundraisingPageStatus } from '../../store/fundraisingPage'
import { selectCampaign } from '../../store/site'

import NotFound from '../../components/container/NotFound'
import Status from '../../components/container/Status'
import SupporterPage from '../../components/container/SupporterPage'
import Theme from '../../components/utils/Theme'

const CustomSupporterPage = ({
  customSupporterPage,
  location,
  router,
  status = 'fetching'
}) => (
  <Theme>
    <Status status={status}>
      {customSupporterPage
        ? (
          <SupporterPage
            customSupporterPage={customSupporterPage}
            key={router.params.slug}
            showLogin={location.query.login}
          />
        ) : <NotFound />}
    </Status>
  </Theme>
)

const mapState = (state, props) => ({
  customSupporterPage: selectCustomSupporterPage(state, props),
  status: selectFundraisingPageStatus(state, props)
})

const hooks = {
  fetch: ({ dispatch, params, state }) => {
    const campaign = selectCampaign(state)
    const customSupporterPage = selectCustomSupporterPage(state)
    const page = selectFundraisingPage(state)
    const status = selectFundraisingPageStatus(state)

    if (status === 'fetched' && page.slug === params.slug) {
      return Promise.resolve(page)
    } else if (!customSupporterPage) {
      return Promise.resolve()
    } else {
      return dispatch(fetchFundraisingPage(params.slug, campaign))
    }
  }
}

export default compose(
  connect(mapState),
  provideHooks(hooks)
)(CustomSupporterPage)
